module.exports = __webpack_public_path__ + "bo.197a9d20.svg";